import { render, staticRenderFns } from "./CategoryTreeNode.vue?vue&type=template&id=74bae437&lang=html&"
import script from "./CategoryTreeNode.vue?vue&type=script&lang=js&"
export * from "./CategoryTreeNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports